/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WriteOnlyVerifyJSONWebTokenSerializer
 */
export interface WriteOnlyVerifyJSONWebTokenSerializer {
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyVerifyJSONWebTokenSerializer
     */
    token: string;
}

export function WriteOnlyVerifyJSONWebTokenSerializerFromJSON(json: any): WriteOnlyVerifyJSONWebTokenSerializer {
    return WriteOnlyVerifyJSONWebTokenSerializerFromJSONTyped(json, false);
}

export function WriteOnlyVerifyJSONWebTokenSerializerFromJSONTyped(json: any, ignoreDiscriminator: boolean): WriteOnlyVerifyJSONWebTokenSerializer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function WriteOnlyVerifyJSONWebTokenSerializerToJSON(value?: WriteOnlyVerifyJSONWebTokenSerializer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
    };
}


